import { siteInfo, footerPartners, navItems } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              桔子视频聚合91视频网站、久久视频、菠萝视频等优质资源，提供高清免费在线观看服务，电视剧全集电影大全每日同步更新，流畅不缓冲。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['91视频网站', '久久视频', '91在线视频', '菠萝视频', '高清在线观看', '电视剧全集'].map(
                (tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 text-xs text-background-300 border border-background-600 rounded-full whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ),
              )}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              {footerPartners.title}
            </h4>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              {footerPartners.description}
            </p>
            <div className="flex items-center gap-4">
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="w-9 h-9 flex items-center justify-center bg-background-700 rounded-lg hover:bg-primary-500 transition-colors">
                <i className="ri-mail-line text-background-50"></i>
              </a>
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="w-9 h-9 flex items-center justify-center bg-background-700 rounded-lg hover:bg-primary-500 transition-colors">
                <i className="ri-information-line text-background-50"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} - 高清视频在线观看平台
          </p>
          <p className="text-xs text-background-500">
            本站内容均来自网络公开资源，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}